module.exports = __webpack_public_path__ + "static/media/segment1.93a48676.png";